import React, { useEffect, useState } from "react";
import { colors } from "../utils/constants";
import { parse, isValid, format, isAfter, isBefore } from 'date-fns';
import { enAU } from 'date-fns/locale';
import { db } from "../firebase-config";
import { addDoc, and, collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { getFirebaseDocs } from "../utils/common";

const Dashboard = () => {

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [date, setDate] = useState('')
    const [errorMessage, setErrorMessage] = useState('')

    const [errors, setErrors] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        const userId = window.localStorage.getItem('config:userId')
        if (userId) {
            retrieveUser(userId)
        }
    }, [])

    const retrieveUser = async (userId) => {
        const resp = await (await getDoc(doc(db, 'users', userId))).data()
        if (!!resp) {
            navigate('/pickDate')
        }
    }


    const errorChecks = [
        { name: 'firstName', value: firstName },
        { name: 'lastName', value: lastName },
        { name: 'email', value: email },
        { name: 'phone', value: phone },
        { name: 'date', value: date },
    ]

    const handleSubmit = async () => {
        let tempErrors = []
        errorChecks.forEach(({ name, value }) => {
            if (!value) {
                tempErrors.push(name)
            }
        })
        if (tempErrors.length === 0) {
            // Check if valid date

            if (!(isAfter(new Date(date), new Date('01/01/2000')) && isBefore(new Date(date), new Date('01/01/2023')))) {
                setErrors(['date'])
                setErrorMessage('Age of child should be between 1 and 16 years')
                return
            }
            if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                setErrors(['email'])
                setErrorMessage('Please enter a valid email address.')
                return
            } else if (phone.length != 10 || !/^\d+$/.test(phone)) {
                setErrors(['phone'])
                setErrorMessage('Please enter a valid phone number.')
                return
            }

            setErrorMessage('')
            setErrors([])

            // Check if baby details exist already?

            const existingDocs = await getFirebaseDocs(await getDocs(await query(collection(db, 'users'), where('email', '==', email), where('date', '==', date), where('name', '==', `${firstName} ${lastName}`))))

            if (existingDocs.length > 0) {
                window.localStorage.setItem(`config:userId`, existingDocs[0].id)
            } else {
                const resp = await addDoc(collection(db, 'users'), { name: `${firstName} ${lastName}`, email, phone, date })
                window.localStorage.setItem(`config:userId`, resp.id)
            }
            navigate('/pickDate')

        } else {
            setErrors(tempErrors)
            setErrorMessage('Please fill in all the fields.')
        }
    }

    return (<div className="container">
        <div className="row">
            <label>Child's First Name</label>
            <input type="text" value={firstName} className={errors.includes('firstName') ? 'error' : ''} placeholder="Child's First Name" onChange={({ target: { value } }) => setFirstName(value)} />
        </div>
        <div className="row">
            <label>Child's Last Name</label>
            <input type="text" value={lastName} className={errors.includes('lastName') ? 'error' : ''} placeholder="Child's Last Name" onChange={({ target: { value } }) => setLastName(value)} />
        </div>
        <div className="row">
            <label>Child's Date of Birth</label>
            {/* <div className="date-block">
                <input type="number" value={dd} className={errors.includes('date') ? 'error' : ''} placeholder="DD" onChange={({ target: { value } }) => setDD(value)} />
                <p>/</p>
                <input type="number" value={mm} className={errors.includes('date') ? 'error' : ''} placeholder="MM" onChange={({ target: { value } }) => setMM(value)} />
                <p>/</p>
                <input type="number" value={yyyy} className={errors.includes('date') ? 'error' : ''} placeholder="YYYY" onChange={({ target: { value } }) => setYYYY(value)} />
            </div> */}
            <input type="date" value={date} className={errors.includes('date') ? 'error' : ''} placeholder="DD/MM/YYYY" onChange={({ target: { value } }) => setDate(value)} />

        </div>
        <div className="row">
            <label>Email</label>
            <input type="email" className={errors.includes('email') ? 'error' : ''} value={email} placeholder="email@domain.com" onChange={({ target: { value } }) => setEmail(value)} />
        </div>
        <div className="row">
            <label>Phone</label>
            <input type="tel" className={errors.includes('phone') ? 'error' : ''} value={phone} placeholder="04xxxxxxxx" onChange={({ target: { value } }) => setPhone(value)} />
        </div>
        {errorMessage && <p style={{ margin: '10px auto', textAlign: 'center', color: colors.red }}>{errorMessage}</p>}
        <button onClick={handleSubmit}>Continue</button>
    </div>)
}

export default Dashboard